// extracted by mini-css-extract-plugin
export default {"wrap":"BsaTree_wrap__sy+JE","searchInput":"BsaTree_searchInput__TIWhv","divider":"BsaTree_divider__5683H","tree":"BsaTree_tree__f5DlF"};